export enum ContainerStatuses {
  Creating = 'CREATING',
  Active = 'ACTIVE',
  Deleting = 'DELETING',
  Failed = 'FAILED',
  ActionFailed = 'ACTION_FAILED',
  Stopping = 'STOPPING',
  Stopped = 'STOPPED',
  Starting = 'STARTING',
  Restarting = 'RESTARTING',
  Reloading = 'RELOADING',
  Moving = 'MOVING',
  Upgrading = 'UPGRADING'
}
